import { render, staticRenderFns } from "./FloatingConsult.vue?vue&type=template&id=28dcd51f&scoped=true"
import script from "./FloatingConsult.vue?vue&type=script&lang=js"
export * from "./FloatingConsult.vue?vue&type=script&lang=js"
import style0 from "./FloatingConsult.vue?vue&type=style&index=0&id=28dcd51f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dcd51f",
  null
  
)

export default component.exports